module.exports = __webpack_public_path__ + "img/vpn-3.afb75740.webp";